'use strict';

import mainApi from '@/assets/js/api/modules/main';

export default {
  namespaced: true,
  state: {
    token: undefined,
    user_info: undefined
  },
  getters: {
    getToken: state => state.token,
    getUserInfo: state => state.user_info
  },
  mutations: {
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_USER_INFO(state, payload) {
      state.user_info = payload;
    },
    CLEAR_STATE(state) {
      state.token = undefined;
      state.user_info = undefined;
    }
  },
  actions: {
    setToken(context, payload) {
      context.commit('SET_TOKEN', payload);
    },
    login(context, payload) {
      const { data, config, apiCancelToken } = payload || {};

      return new Promise((resolve, reject) => {
        // const token = window.btoa(Math.floor(Math.random() * Date.now()).toString(36).substr(2)); // Encode To Base64
        // context.commit('SET_TOKEN', token);
        // resolve({ token });
        mainApi.postData({ url: '/api/admin/login', data, config, apiCancelToken }).then(
          (response) => {
            // console.log(response.data.token);
            context.commit('SET_TOKEN', response.data.token);
            resolve(response.data);
          }
        ).catch(
          (error) => {
            // console.log(error);
            context.dispatch('error', error, { root: true });
            reject(error);
          }
        );
      });
    },
    // fetchUserInfo(context, payload) {
    //   const { config, apiCancelToken } = payload || {};
    //   return new Promise((resolve, reject) => {
    //     mainApi.getData({ url: '/auth/me', config, apiCancelToken }).then(
    //       (response) => {
    //         // console.log(response);
    //         context.commit('SET_USER_INFO', response.data);
    //         resolve(response);
    //       }
    //     ).catch(
    //       (error) => {
    //         // console.log(error);
    //         context.dispatch('error', error, { root: true });
    //         reject(error);
    //       }
    //     );
    //   });
    // }
  }
};